import React from 'react';

import { flagStyles } from '../settings';

const SvgMN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3480px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMN;
